
export default {
  /**
   * 法人の船舶一覧を取得
   * @param context
   */
  getVessels(state) {
    return state.vessels || []
  },
  /**
   * ページング取得
   * @param state
   * @returns {[]}
   */
  getPageable: state => state.pageable,
}
